<div class="form-group flex-1 w-100">
  <label
    ><ng-container>{{ label }}</ng-container></label
  >
  <input type="text" [readonly]="disabled" [value]="time || '00:00:00'" (input)="onTimeChange($event)" [className]="'html-duration-picker form-control'" />
</div>
